import React from "react";

const Input = ({ name, label, error, req, size, icon, ...rest }) => {
  return (
    <div className={`${label ? "form-group" : ""} ${req ? " required" : ""}`}>
      {label &&
        <label className="form-control-label" htmlFor={name}>
          {icon && <i className={`fa ${icon}`} style={{ marginRight: '6px' }} />}
          {label}
        </label>}
      <div className={icon ? "wf-input-wrap" : ""}>
        {icon && <i className={`fa ${icon} wf-input-icon`} aria-hidden="true" />}
        <input
          {...rest}
          id={name}
          name={name}
          className={`form-control ${size === "s" ? "form-control-sm" : ""} ${icon ? "wf-input-withicon" : ""}`}
          placeholder={label}
        />
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Input;
